module.exports = __webpack_public_path__ + "img/Instagram.svg.234f3206.png";